<micro-lookup domain="domain" obj="nets" url="/nets" [key]="netId" [link]="link"></micro-lookup>
